<template>
  <div id="GjwCategoryDisplay" class="flex-align-center">
    <span class="mg-rt-sm">{{ nodeName }}</span>
    <el-popover placement="bottom" trigger="hover">
      <div class="category-popover">
        <p class="name-line">{{ nodeName }}</p>
        <p v-for="(nodePath, index) in nodePaths" :key="index" class="path-line">
          {{ nodePath }}
        </p>
      </div>
      <div v-show="nodeName" slot="reference" class="flex-align-center path-box">
        <i class="gjw-iconfont gjw-icon-fenlei ft-12" />
        <span v-if="nodePathNum > 1" class="path-number">{{ nodePathNum }}</span>
      </div>
    </el-popover>
  </div>
</template>

<script>
import Utils from '@/core/utils'
export default {
  name: 'GjwCategoryDisplay',
  props: {
    // 末级节点的分类code
    nodeCode: {
      type: [String, Number],
      default: ''
    },
    // 分类总池子
    platSourceArr: {
      type: Array,
      default() {
        return []
      }
    },
    // 分类唯一标志的key
    nodeKey: {
      type: String,
      default: 'id'
    },
  },
  computed: {
    nodeName() {
      const nodeCode = this.nodeCode
      const sourceArr = this.platSourceArr || []
      const nodeKey = this.nodeKey
      const itemObj = sourceArr.find((item) => item[nodeKey] === nodeCode) || {}
      return itemObj.name || ''
    },
    // 包含末级节点的全部路径
    nodePaths() {
      const nodeCode = this.nodeCode
      const sourceArr = this.platSourceArr
      const nodeKey = this.nodeKey
      const parentKey = nodeKey === 'id' ? 'parentId' : 'parentCode'
      // const rootObj = sourceArr.find((item) => item[parentKey] === null) || {}
      const ret = []
      sourceArr.forEach((item) => {
        if (item[nodeKey] === nodeCode) {
          const parentCode = item[parentKey]
          let itemPathStr = ''
          if (parentCode || parentCode === 0) {
            const fnName = nodeKey === 'id' ? 'getPathByChild' : 'getPathByChildCode'
            const { names } = Utils[fnName](sourceArr, parentCode)
            itemPathStr = names.join(' > ') + ` > ${item.name}`
          } else {
            itemPathStr = `${item.name}`
          }
          ret.push(itemPathStr)
        }
      })
      return ret
    },
    nodePathNum() {
      return this.nodePaths ? this.nodePaths.length : 0
    }
  }
}
</script>

<style lang="less" scoped>
.path-box{
  padding: 2px 8px;
  height: 20px;
  border-radius: 157px;
  background: #E8E8E8;
  .iconfont{
    margin-bottom: 2px;
  }
  .path-number{
    margin-left: 2px;
  }
}
.name-line{
  margin-bottom: 8px;
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.85);
}
.path-line{
  margin-bottom: 6px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
}
</style>
